import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const CVLAModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 7', 'Module 4', 'Module 5', 'Module 6'
  ];

  const subtopicsData = {
    'Module 1': [
      { name: 'Analytic function', path: '/cvla-m1-s1' },
      { name: 'Harmonic conjugate', path: '/cvla-m1-s2' },
      { name: 'Milne Thomson method', path: '/cvla-m1-s3' },
      { name: 'Polar form', path: '/cvla-m1-s4' },
      { name: 'Application in analytic function', path: '/cvla-m1-s5' }
    ],
    'Module 2': [
      { name: 'Elementary Transformations in Conformal Mapping', path: '/cvla-m2-s1' },
      { name: 'Special transformation', path: '/cvla-m2-s2' },
      { name: 'Bilinear transformation', path: '/cvla-m2-s3' }
    ],
    'Module 3': [
      { name: 'Taylor’s series', path: '/cvla-m3-s1' },
      { name: "Laurent's series", path: '/cvla-m3-s2' },
      { name: 'Cauchy Integral formula', path: '/cvla-m3-s3' },
      { name: 'Singularity and poles', path: '/cvla-m3-s4' },
      { name: 'Cauchy residue theorem', path: '/cvla-m3-s5' },
      { name: 'Contour Integration', path: '/cvla-m3-s6' }
    ],
    'Module 7': [
      { name: 'System of linear equations', path: '/cvla-m7-s1' },
      { name: 'Eigen values and eigen vectors', path: '/cvla-m7-s2' },
      { name: 'Cayley Hamilton theorem', path: '/cvla-m7-s3' }
    ],
    'Module 4': [
      { name: 'Vector Space', path: '/cvla-m4-s1' },
      { name: 'Basis and Dimension', path: '/cvla-m4-s2' }
    ],
    'Module 5': [
      { name: 'Linear Transformation', path: '/cvla-m5-s1' },
      { name: 'Matrix Representation of Linear Transformation', path: '/cvla-m5-s2' },
      { name: 'Change of Basis', path: '/cvla-m5-s3' }
    ],
    'Module 6': [
      { name: 'Inner Product Space', path: '/cvla-m6-s1' },

    ],

  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Complex Variables and Linear Algebra</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module]?.length ? (
                  subtopicsData[module].map((topic, index) => (
                    <li key={index}>
                      <span>{topic.name}</span>
                      <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-CVLAModules' }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Coming Soon...</li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CVLAModules;
